"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStimulus = void 0;
const __1 = require("../../..");
const camelize_1 = require("./camelize");
const taskStore_1 = require("../../../taskStore");
const taskSetup_1 = require("../../taskSetup");
const appTimer_1 = require("./appTimer");
// This function reads the corpus, calls the adaptive algorithm to select
// the next item, stores it in a session variable, and removes it from the corpus
// corpusType is the name of the subTask's corpus within corpusLetterAll[]
const getStimulus = (corpusType, blockNumber, storyGroup, randomize = false) => {
    let corpus, itemSuggestion;
    corpus = (0, taskStore_1.taskStore)().corpora;
    if (blockNumber != null) {
        // if block number is specified, get next item from only the indicated block of the corpus
        itemSuggestion = taskSetup_1.cat.findNextItem(corpus[corpusType][blockNumber]);
    }
    else if (storyGroup != null) {
        // if story group is specified (only for ToM), get next item from only the indicated story group of the corpus
        const storyGroupStimuli = corpus[corpusType].filter((stimulus) => stimulus.storyGroup === storyGroup);
        if (randomize) {
            const nextItem = storyGroupStimuli[Math.floor(Math.random() * storyGroupStimuli.length)];
            const remainingStimuli = corpus[corpusType].filter((stimulus) => stimulus.itemId !== nextItem.itemId);
            itemSuggestion = {
                nextStimulus: nextItem,
                remainingStimuli: remainingStimuli,
            };
        }
        else {
            itemSuggestion = taskSetup_1.cat.findNextItem(storyGroupStimuli);
        }
    }
    else {
        itemSuggestion = taskSetup_1.cat.findNextItem(corpus[corpusType]);
    }
    const stimAudio = itemSuggestion.nextStimulus.audioFile;
    if (typeof stimAudio === 'string') {
        if (stimAudio && !__1.mediaAssets.audio[(0, camelize_1.camelize)(stimAudio)]) {
            console.warn('Trial skipped. Audio file not found:', stimAudio);
            (0, taskStore_1.taskStore)('skipCurrentTrial', true);
            // ends the setup timeline
            taskSetup_1.jsPsych.endCurrentTimeline();
        }
    }
    else {
        const audioAssets = stimAudio.map((audio) => (0, camelize_1.camelize)(audio));
        if (audioAssets.some((audioAsset) => !__1.mediaAssets.audio[audioAsset])) {
            console.warn('Trial skipped. Audio file(s) not found:', audioAssets);
            (0, taskStore_1.taskStore)('skipCurrentTrial', true);
            // ends the setup timeline
            taskSetup_1.jsPsych.endCurrentTimeline();
        }
    }
    // end task if there is not enough time to display next stimulus
    const maxTimeInMilliseconds = (0, taskStore_1.taskStore)().maxTime * 60000;
    const timeElapsed = (0, appTimer_1.getActiveTaskElapsedMs)();
    const timeRemaining = maxTimeInMilliseconds - timeElapsed;
    (0, appTimer_1.checkEndTaskEarly)(timeRemaining, stimAudio);
    // store the item for use in the trial
    (0, taskStore_1.taskStore)('nextStimulus', itemSuggestion.nextStimulus);
    if (itemSuggestion.nextStimulus.assessmentStage === 'practice_response') {
        (0, taskStore_1.taskStore)('testPhase', false);
    }
    // update the corpus with the remaining unused items
    blockNumber != null
        ? (corpus[corpusType][blockNumber] = itemSuggestion.remainingStimuli)
        : (corpus[corpusType] = itemSuggestion.remainingStimuli);
    (0, taskStore_1.taskStore)('corpora', corpus);
};
exports.getStimulus = getStimulus;
